import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import Home from "../pages/Home";
import About from "../pages/About";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsAndConditions from "../pages/TermsAndConditions";
import InformationSecurity from "../pages/InformationSecurity";
import Services from "../pages/Services";
import ContactUs from "../pages/ContactUs";
import Industries from "../pages/Industries";
import Industry from "../pages/Industry";
import Insights from "../pages/Insights";
import SterlingPeakReadiness from "../pages/SterlingPeakReadiness";
import IndustryContent from "../pages/IndustryContent";

const AppRoutes = () => (
  <Router>
    <MainLayout>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/information-security" element={<InformationSecurity />} />
        {/* <Route path="/services/:service" element={<Services />} /> */}
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/industries" element={<IndustryContent />} />
        <Route path="/industries/:slug" element={<IndustryContent />} />
        <Route
          path="/sterling-peak-readiness-advisory"
          element={<SterlingPeakReadiness />}
        />
        {/* <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:industry" element={<Industry />} />
        <Route path="/insights" element={<Insights />} /> */}

      </Routes>
    </MainLayout>
  </Router>
);

export default AppRoutes;
